import baseAPI from '@/http'

const router = 'api/municipio/membro'

export const membrosApi = {
    getMembroByMunicipio: (municipioId) => baseAPI.post(`${router}/get-membro-by-municipio/${municipioId}`),

}
